<template src="./Searchbar.html"></template>
<style src="./Searchbar.scss" lang="scss"></style>

<script>
	import Input from '@/components/Input/Input';

	/**
	 * The searchbar with button in the homepage.
	 * @vue-data {Object} searchbarInput An object representing the input bar for search
	 * @vue-data {string} searchURL The endpoint where searchbar should lead to
	 * @vue-data {Object} trackParam An object representing tracking parameters for search and suggest
	 * @vue-data {number} suggestIndex The chosen suggest link
	 */
	export default {
		name: 'HpSearchbar',
		data () {
			return {
				searchbarInput: {
					htmlId: 'searchbar' + this._uid,
					inputType: 'search',
					ariaPlaceholder: 'google', // for identifying search machine
					inputvalue: '',
					name: 'q',
					maxLength: 1024,
					suggest: {
						id: this.$store.state.contentData.searchbar.suggestContainerId,
						url: this.$store.state.contentData.searchbar.suggestAPI,
						response: ''
					}
				},
				searchURL: this.$store.state.contentData.searchbar.searchURL,
				trackParam: {
					searchbar: 'HP',
					suggest: 'HP_sg'
				},
				suggestIndex: -1
			};
		},
		methods: {
			/**
			 * Submits search to given endpoint.
			 * @param {Event} event The submit event fired by form
			 */
			searchSubmit (event) {
				event.preventDefault();
				let form = this.$el.querySelector('form') || '';
				// let variant = document.querySelector('html').getAttribute('data-variant-name');

				if (form) {
					if (window.getComputedStyle(document.documentElement).getPropertyValue('--screen-touchable') === 'false') {
						form.origin.value = this.suggestIndex < 0 ? this.trackParam.searchbar : this.trackParam.suggest;
					}
					form.submit();
				} else {
					console.log('Form Not Found');
				}
			},
			/**
			 * Clears input value of search form.
			 */
			searchReset () {
				let form = this.$el.querySelector('form') || '';
				form && form.reset();
				this.searchbarInput.inputvalue = '';
			},
			/**
			 * Gets index of focused or chosen suggest link.
			 * @param obj The object representing search suggest link
			 */
			getSuggestIndex (obj) {
				this.suggestIndex = obj.index;
			},
			getKonami () {
				let keysPressed = '';
				const konamiCode = '38384040373937396665';

				this.$el.addEventListener('keyup', (event) => {
					switch (event.keyCode) {
						case 38:
						case 40:
						case 37:
						case 39:
						case 66:
						case 65:
							keysPressed += event.keyCode;
							break;
						case 27:
						default:
							keysPressed = '';
					}

					if (keysPressed === konamiCode) {
						let searchForm = event.currentTarget.querySelector('[data-component="searchbar"] form');

						if (searchForm) {
							let searchBar = searchForm.querySelector('input[id^="searchbar"]');
							if (searchBar) {
								searchBar.value = 'Konami Code';
								searchForm.submit();
							}
						}
					} else if (keysPressed.length >= konamiCode.length) {
						keysPressed = '';
					}
				});
			}
		},
		components: {
			'hp-input': Input
		},
		mounted () {
			this.getKonami();
		}
	};
</script>
